import { Component, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { rxResource } from '@angular/core/rxjs-interop';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalComponent, ModalButton } from '../../../common-components/modal/modal.component';
import { AdminBattle, CardsAdminService } from '../../../services/admin/cards-admin.service';

@Component({
  selector: 'app-cards-battles-tab',
  imports: [TranslocoModule, ModalComponent, DatePipe],
  templateUrl: './cards-battles-tab.component.html',
  styleUrl: './cards-battles-tab.component.scss'
})
export class CardsBattlesTabComponent {
  battles = rxResource({ stream: () => this.cardsAdmin.getBattles$(), defaultValue: [] });

  showCancelModal = signal(false);
  selectedBattle = signal<AdminBattle | null>(null);

  cancelModalButtons: ModalButton[] = [
    { type: 'secondary', text: this.transloco.translate('Cancel'), onClick: () => this.closeCancel() },
    { type: 'error', text: this.transloco.translate('cardsAdminForceCancel'), onClick: () => this.confirmCancel() }
  ];

  constructor(
    private cardsAdmin: CardsAdminService,
    private transloco: TranslocoService,
    private snackBar: MatSnackBar
  ) {}

  openCancel(battle: AdminBattle): void {
    this.selectedBattle.set(battle);
    this.showCancelModal.set(true);
  }

  closeCancel(): void {
    this.showCancelModal.set(false);
  }

  confirmCancel(): void {
    const battle = this.selectedBattle();
    if (!battle) {
      return;
    }
    this.cardsAdmin.forceCancelBattle$(battle.id).subscribe(() => {
      this.showCancelModal.set(false);
      this.snackBar.open(this.transloco.translate('cardsAdminCancelled'), '', { duration: 3000 });
      this.battles.reload();
    });
  }
}
